'use strict';

var processInclude = require('base/util');
$(document).ready(function () {
    processInclude(require('./login/login'));
    processInclude(require('passwordless_custom/passwordlessLogin/login'));
    processInclude(require('./components/errorNotification'));
    processInclude(require('ds_global/components-dsl/passwordInput'));
});
